// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type Scope } from "~/hooks/useScope";
import { SUPPRESS_INTEGRATION_MESSAGE } from "./action";

export function canSuppressIntegrationMessage(scope: Scope): boolean {
  return scope.iamActions.includes(SUPPRESS_INTEGRATION_MESSAGE);
}
